export const IMPORT_SERIALIZED_IMPORTING = 'importing'
export const IMPORT_SERIALIZED_IMPORTING_TABLE_STRUCTURE =
  'importing-table-structure-'
export const IMPORT_SERIALIZED_IMPORTING_TABLE_DATA = 'importing-table-data-'
export const EXPORT_SERIALIZED_EXPORTING = 'exporting'
export const EXPORT_SERIALIZED_EXPORTING_TABLE = 'exporting-table-'
export const EXPORT_WORKSPACE_CREATE_ARCHIVE = 'create-archive'
export const WORKSPACE_EXPORT_MANIFEST_FILENAME = 'manifest.json'
export const WORKSPACE_EXPORT_MANIFEST_CANDIDATES = [
  WORKSPACE_EXPORT_MANIFEST_FILENAME,
  `./${WORKSPACE_EXPORT_MANIFEST_FILENAME}`,
]
export const DEVELOPMENT_STAGES = {
  BETA: 'beta',
  ALPHA: 'alpha',
}
